<template>
    <el-main class="w-full p-6 box-border overflow-auto h-[calc(100vh-60px)]" @contextmenu.prevent="openMenu($event)">
        <router-view v-if="appStore.isRouterAlive" />

        <div v-if="appStore.isMenuVisible" class="fixed z-30 transition-all origin-top-left"
            :style="{ top: `${menuPosition.y}px`, left: `${menuPosition.x}px` }">
            <ul class="list-none text-center leading-8">
                <li class="w-25 h-8 cursor-pointer bg-blue-100/80 rounded-md" @click="menuAction">刷 新</li>
            </ul>
        </div>
    </el-main>
</template>

<script lang="ts" setup>
import { useAppStore } from '@/stores'
import { reactive } from 'vue'

const appStore = useAppStore()
const menuPosition = reactive({
    x: 0,
    y: 0
})


const openMenu = (event: { clientX: number; clientY: number; }) => {
    // 获取鼠标点击位置
    menuPosition.x = event.clientX;
    menuPosition.y = event.clientY;
    appStore.isMenuVisible = true
}

const closeMenu = () => {
    appStore.isLoading = false
    appStore.isRouterAlive = true
}

const menuAction = () => {
    appStore.isMenuVisible = false;
    appStore.isRouterAlive = false
    appStore.isLoading = true

    setTimeout(() => {
        closeMenu();
    }, 10);
}

</script>